'use strict';

// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import _ from 'lodash';
import { Progress } from 'react-sweet-progress';

// Services
import LANG from './lang.js';

const BadgesOverview = ({ rarities, badges }) => {
	const COLOURS = {
		Common: '#666666',
		Uncommon: '#4A82FF',
		Rare: '#67941f'
	};

	const headingCells = _.map(rarities, rarity => {
		const totalBadgesOfRarity = _.filter(badges, badge => badge.rarity === rarity);
		const completedBadgesOfRarity = _.filter(totalBadgesOfRarity, badge => badge.unlocked);
		const percentage = Math.round(
			completedBadgesOfRarity.length / totalBadgesOfRarity.length * 100
		);

		return (
			<div className={classnames('cell', 'rarity-' + rarity)} key={rarity}>
				<Progress
					type="circle"
					percent={percentage}
					width="10rem"
					status="active"
					theme={{ active: { color: COLOURS[rarity] } }}
				/>
				<div className="columnHeading">{LANG.HEADINGS[rarity.toUpperCase()]}</div>
			</div>
		);
	});

	return (
		<div className="badgeRow headingRow">
			<div className="rowHeader">{LANG.ROW_HEADER}</div>
			<div className="rowContents">{headingCells}</div>
		</div>
	);
};

BadgesOverview.propTypes = {
	badges: PropTypes.arrayOf(PropTypes.object).isRequired,
	rarities: PropTypes.arrayOf(PropTypes.string.isRequired)
};

export default BadgesOverview;
